var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FCFC00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 16.3963C17.8984 16.9178 17.6538 17.355 17.2005 17.6655C16.8867 17.8802 16.5392 17.9994 16.1521 17.9994C13.3847 17.9994 10.6174 18.0013 7.85003 17.9982C6.86628 17.9969 6.02141 17.1769 6.00084 16.217C5.96001 14.3106 7.41988 12.6324 9.36005 12.3557C9.60341 12.321 9.84774 12.3025 10.0937 12.3025C11.3973 12.3031 12.7009 12.2966 14.0042 12.3047C15.1613 12.3119 16.1527 12.7147 16.9478 13.541C17.5316 14.1479 17.872 14.8705 17.9775 15.6968C17.982 15.7325 17.9923 15.7676 17.9997 15.8032V16.3963H18Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4209 5C12.9877 5.09296 13.5149 5.28012 13.9721 5.62784C14.8379 6.28636 15.2876 7.15771 15.2699 8.22185C15.2433 9.82808 14.0229 11.1144 12.3791 11.3213C10.6338 11.5407 8.96076 10.2656 8.76112 8.56394C8.55698 6.82532 9.75548 5.28888 11.5265 5.01815C11.5474 5.01502 11.5671 5.00626 11.5876 5C11.8654 5 12.1435 5 12.4212 5H12.4209Z",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e08ff5b0f6ed76bca3efbebe01247759.svg";
export { ForwardRef as ReactComponent };